import { useEffect } from 'react';

const BASE_URL = 'https://www.lazuli.marketing';
const DEFAULT_IMAGE = `${BASE_URL}/logo_blue.webp`;
const SITE_NAME = 'Lazuli Marketing';

function setMeta(attr, key, content) {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setCanonical(href) {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function PageMeta({ title, description, path = '/', image }) {
  const fullTitle = title.includes('Lazuli') ? title : `${title} | ${SITE_NAME}`;
  const url = `${BASE_URL}${path}`;
  const img = image ? `${BASE_URL}${image}` : DEFAULT_IMAGE;

  useEffect(() => {
    document.title = fullTitle;
    setMeta('name', 'description', description);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:site_name', SITE_NAME);
    setMeta('property', 'og:title', fullTitle);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', url);
    setMeta('property', 'og:image', img);
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', fullTitle);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:image', img);
    setCanonical(url);
  }, [fullTitle, description, url, img]);

  return null;
}
